var _excluded = ["className", "disabled", "rows", "value", "onPressEnter", "onChange", "onValueChange", "onKeyDown", "invalid", "filled", "feildMark", "fieldMark", "clearable", "showCount", "onMouseEnter", "onMouseLeave", "inputStyle", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState } from 'react';
import { useCombineCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { classnames, isFunction, isUndefined } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { InputWrapper } from '../../units/input-wrapper';
import { CloseOne } from '../../common/icons';
export function TextArea(props, state) {
  var _a;

  var className = props.className,
      disabled = props.disabled,
      rows = props.rows,
      value = props.value,
      onPressEnter = props.onPressEnter,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onKeyDown = props.onKeyDown,
      invalid = props.invalid,
      filled = props.filled,
      feildMark = props.feildMark,
      _props$fieldMark = props.fieldMark,
      fieldMark = _props$fieldMark === void 0 ? feildMark : _props$fieldMark,
      clearable = props.clearable,
      _props$showCount = props.showCount,
      showCount = _props$showCount === void 0 ? false : _props$showCount,
      propsOnMoseEnter = props.onMouseEnter,
      propsOnMouseLeave = props.onMouseLeave,
      inputStyle = props.inputStyle,
      style = props.style,
      extra = _objectWithoutProperties(props, _excluded);

  var locale = useLocale('textarea.placeholder');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var onMouseEnter = useCombineCallback(propsOnMoseEnter, function () {
    return setHover(true);
  });
  var onMouseleave = useCombineCallback(propsOnMouseLeave, function () {
    return setHover(false);
  });
  var onPressEnterCallback = useRefCallback(onPressEnter);
  var onChangeCallback = useRefCallback(onChange);
  var onKeyDownCallback = useRefCallback(onKeyDown);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var handleTextareaChange = useCallback(function (e) {
    onChangeCallback(e);
    onValueChangeCallback(e.target.value);
  }, []);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      onPressEnterCallback(e);
    }

    onKeyDownCallback(e);
  };

  var cls = classnames(usePrefixCls('text', {
    disabled: disabled
  }), usePrefixCls('text', {
    enabled: !disabled
  }), usePrefixCls('text', {
    warning: invalid && !disabled
  }), usePrefixCls('text', {
    filled: filled
  }), usePrefixCls('text', {
    clearable: !!clearable
  }), usePrefixCls('text', {
    count: !!showCount
  }), className);
  var wrapperCls = classnames(usePrefixCls('text-wrapper', {
    'whole-line': isUndefined(inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.width)
  }));
  var clearCls = classnames(usePrefixCls('text-close-icon'));
  var numbersCls = classnames(usePrefixCls('text-show-count', {
    position: true
  }));

  var renderNumberTotal = function renderNumberTotal() {
    if (isFunction(showCount)) {
      return React.createElement("span", {
        className: usePrefixCls('text-show-count-position')
      }, ' ', showCount());
    } else {
      return showCount && React.createElement("span", {
        className: numbersCls
      }, value === null || value === void 0 ? void 0 : value.length, " / ", extra.maxLength);
    }
  };

  return React.createElement(InputWrapper, _objectSpread(_objectSpread({}, extra), {}, {
    inputStyle: inputStyle,
    style: _objectSpread({
      maxWidth: inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.maxWidth,
      minWidth: inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.minWidth
    }, style),
    tag: "textarea",
    rows: rows,
    disabled: disabled,
    placeholder: (_a = extra.placeholder) !== null && _a !== void 0 ? _a : locale,
    value: value,
    inputClassName: cls,
    onKeyDown: handleKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseleave,
    className: wrapperCls,
    onChange: handleTextareaChange,
    fieldMark: fieldMark,
    renderCount: renderNumberTotal,
    clear: !disabled && hover && clearable && React.createElement(CloseOne, {
      theme: "filled",
      className: clearCls
    })
  }));
}